export default __webpack_public_path__ + "static/media/akar-icons_location-small.ca105a3a.svg";